import { RerunRequirement } from "shared/types";

const rerunRequirementMessages = {
  [RerunRequirement.DecisionHasBeenMade]:
    "You can re-run the {reportName} until a decision has been made",
  [RerunRequirement.Pass60DaysPeriod]:
    "You can re-run the {reportName} within 60 days after the application has been submitted"
};

export const getRerunRequirementMessage = ({
  requirement,
  reportName
}: {
  requirement?: RerunRequirement;
  reportName?: string;
}): string => {
  const message = rerunRequirementMessages[requirement || ""];

  if (!message || !reportName) return "";

  const lowerCaseReportName = reportName.toLowerCase();
  return message.replace("{reportName}", lowerCaseReportName);
};
